export const allMetalordNFTContractsDeployed = async (
  metalordNFTManagerContract,
  index
) => {
  return await metalordNFTManagerContract.allMetalordNFTContractsDeployed(
    index
  );
};

export const isSupportedNFT = async (
  metaspaceNFTMarketplaceContract,
  index
) => {
  return await metaspaceNFTMarketplaceContract.isSupportedNFT(index);
};

export const nftInfo = async (nftContract, addresses, index) => {
  return await nftContract.nftInfo(addresses, index);
};

export const getNFTInfo = async (nftContract, addresses, index) => {
  return await nftContract.getNFTInfo(addresses, index);
};

export const getName = async (nftContract) => {
  return await nftContract.name();
};

export const totalSupply = async (nftContract) => {
  return await nftContract.totalSupply();
};

export const updateSupportedCurrency = async (nftContract, currency) => {
  return await nftContract.updateSupportedCurrency(currency, true);
};
